//----- Component --------------------------------------------------------/
// Developer     : Guillermo Sedran
// Creation Date : 04/02/2025
// Version       : 1
// Description   : Drawer para abrir/cerrar gráfico de observaciones
//
//------Changes ----------------------------------------------------------------------------------//
// Change Date   :
// Change by     :
// Change description:
//
// Change Date   :
// Change by     :
// Change description:
//
//========================================================================/

import { useState } from "react";
import { Button } from "@mui/material";
import ChartObservaciones from "./ChartObservaciones";

const BottomDrawer = ({ vehiculo }) => {
  const [isOpen, setIsOpen] = useState(false);

  // Estilos en objetos de JavaScript
  const styles = {
    drawerContainer: {
      position: "relative",
    },
    toggleButton: {
      position: "fixed",
      bottom: "20px",
      right: "20px",
      zIndex: 1001,
      padding: "10px 20px",
      backgroundColor: "#007bff",
      color: "white",
      border: "none",
      borderRadius: "5px",
      cursor: "pointer",
      transition: "transform 0.3s",
    },
    overlay: {
      position: "fixed",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      zIndex: 999,
      pointerEvents: isOpen ? "auto" : "none", // Solo interactivo cuando está abierto
      opacity: isOpen ? 1 : 0,
      transition: "opacity 0.3s",
    },
    drawer: {
      position: "fixed",
      bottom: isOpen ? "0" : "-50%", // Controla la animación
      left: 0,
      width: "100%",
      height: "50%",
      backgroundColor: "white",
      boxShadow: "0 -2px 10px rgba(0, 0, 0, 0.1)",
      zIndex: 1000,
      transition: "bottom 0.3s ease-out",
      borderTopLeftRadius: "10px",
      borderTopRightRadius: "10px",
    },
    drawerContent: {
      padding: "20px",
      height: "calc(100% - 40px)",
      overflowY: "auto",
    },
  };

  return (
    <div style={styles.drawerContainer}>
      {/* Botón de toggle */}
      <Button
        style={{
          ...styles.toggleButton,
          border: "2px solid white",
          padding: "4px 8px", // Reduce el padding
          fontSize: "0.75rem", // Reduce el tamaño de la fuente
          minWidth: "unset", // Permite que el botón sea más pequeño
          height: "30px", // Ajusta la altura
        }}
        onClick={() => setIsOpen(!isOpen)}
        aria-label={isOpen ? "Cerrar panel" : "Abrir panel"}
        size="small"
      >
        {isOpen ? "▼ Cerrar Gráfico" : "▲ Abrir Gráfico"}
      </Button>

      {/* Overlay (fondo oscuro) */}
      <div style={styles.overlay} onClick={() => setIsOpen(false)} />

      {/* Drawer */}
      <div style={styles.drawer}>
        <div style={styles.drawerContent}>
          <ChartObservaciones vehiculo={vehiculo} />
        </div>
      </div>
    </div>
  );
};

export default BottomDrawer;
